/// <amd-module name="NetSuite.ImageTextOverlay.Instrumentation.Helper"/>
define("NetSuite.ImageTextOverlay.Instrumentation.Helper", ["require", "exports", "NetSuite.ImageTextOverlay.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ComponentArea = 'SC Image Text Overlay';
    var ExtensionVersion = '1.0.3';
    var QueueNameSuffix = '-ImageTextOverlay';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (container) {
            Instrumentation_1.default.initialize({
                environment: container.getComponent('Environment'),
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                }
            });
        };
        InstrumentationHelper.log = function (activity, subType) {
            var label = activity.replace(' ', '');
            var log = Instrumentation_1.default.getLog(label);
            log.setParameter('activity', activity);
            if (subType) {
                log.setParameter('subType', subType);
            }
            log.submit();
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
